'use client';

import { c as _c } from "react/compiler-runtime";
import { Banner, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { usePathname } from 'next/navigation';
import { trackContentfulClick, trackGlobalPromoBanner } from '@libs/analytics';
import type { SiteWidePromoBannerProps } from './types';
import './SiteWidePromoBanner.scss';
export default function SiteWidePromoBanner(t0) {
  const $ = _c(17);
  const {
    text,
    link,
    backgroundColor
  } = t0;
  const pathname = usePathname();
  if (!text) {
    return null;
  }
  let t1;
  if ($[0] !== link || $[1] !== text) {
    t1 = link ? <a href={link.webUrl}>{text}</a> : text;
    $[0] = link;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cta = t1;
  let t2;
  if ($[3] !== link?.webUrl || $[4] !== pathname || $[5] !== text) {
    t2 = () => {
      trackGlobalPromoBanner(text);
      trackContentfulClick({
        linkText: text ?? "",
        linkUrl: link?.webUrl ?? "",
        promoTitle: text ?? "",
        promoVariant: "site wide promo banner",
        promoOrigin: pathname,
        promoDesc: text ?? "",
        promoType: "site wide promo banner"
      });
    };
    $[3] = link?.webUrl;
    $[4] = pathname;
    $[5] = text;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = backgroundColor === "Red";
  const t4 = backgroundColor === "Blue";
  const t5 = backgroundColor === "VIPP";
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = cn("sitewide-promo", {
      "sitewide-promo__red": t3,
      "sitewide-promo__blue": t4,
      "sitewide-promo__vipp": t5
    });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== cta) {
    t7 = <TextPassage align="center"><p>{cta}</p></TextPassage>;
    $[11] = cta;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t6 || $[15] !== t7) {
    t8 = <Banner onClick={t2} className={t6} data-testid="sitewide-promo">{t7}</Banner>;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}